import apiClient from "./apiClient";

export interface CustomerCRMProfile {
  id: string;
  tenant_id: string;
  customer_id: string;
  notes?: string | null;
  tags?: string[] | null;
  account_owner_user_id?: string | null;
  preferred_channel?: string | null;
  credit_status?: string | null;
  next_follow_up_at?: string | null;
  last_contacted_at?: string | null;
  metadata_json?: Record<string, any> | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface CustomerCRMTask {
  id: string;
  tenant_id: string;
  customer_id: string;
  title: string;
  description?: string | null;
  status: string;
  priority: string;
  due_at?: string | null;
  completed_at?: string | null;
  created_by_user_id?: string | null;
  assigned_to_user_id?: string | null;
  task_metadata?: Record<string, any> | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface CRMTaskCounts {
  total: number;
  open: number;
  done: number;
}

export const getCustomerCrmProfile = async (
  customerId: string
): Promise<{ profile: CustomerCRMProfile | null; task_counts: CRMTaskCounts }> => {
  const response = await apiClient.get(`/admin/customers/${customerId}/crm/profile`);
  return response.data;
};

export const upsertCustomerCrmProfile = async (
  customerId: string,
  payload: Partial<CustomerCRMProfile>
): Promise<{ profile: CustomerCRMProfile }> => {
  const response = await apiClient.put(`/admin/customers/${customerId}/crm/profile`, payload);
  return response.data;
};

export const listCustomerCrmTasks = async (
  customerId: string,
  status?: string
): Promise<{ tasks: CustomerCRMTask[] }> => {
  const response = await apiClient.get(`/admin/customers/${customerId}/crm/tasks`, {
    params: status ? { status } : undefined,
  });
  return response.data;
};

export const createCustomerCrmTask = async (
  customerId: string,
  payload: {
    title: string;
    description?: string;
    status?: string;
    priority?: string;
    due_at?: string | null;
    assigned_to_user_id?: string | null;
    task_metadata?: Record<string, any>;
  }
): Promise<{ task: CustomerCRMTask }> => {
  const response = await apiClient.post(`/admin/customers/${customerId}/crm/tasks`, payload);
  return response.data;
};

export const updateCustomerCrmTask = async (
  taskId: string,
  payload: Partial<{
    title: string;
    description: string | null;
    status: string;
    priority: string;
    due_at: string | null;
    assigned_to_user_id: string | null;
    task_metadata: Record<string, any>;
  }>
): Promise<{ task: CustomerCRMTask }> => {
  const response = await apiClient.patch(`/admin/customers/crm/tasks/${taskId}`, payload);
  return response.data;
};
